import { BaseEdge, EdgeProps, getSmoothStepPath } from '@xyflow/react'

const Edge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
}: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  return <BaseEdge path={edgePath} style={{ strokeWidth: 2, stroke: 'grey400' }} />
}

export default Edge
